import { Outlet } from 'react-router-dom';

import styled from 'styled-components';

export default function PolicyLayout() {
  return (
    <SPolicyWrapper>
      <Outlet />
    </SPolicyWrapper>
  );
}

const SPolicyWrapper = styled.div`
  padding: 40px 0 0;
  width: 100vw;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.palette.common.white};
`;
